import gql from 'graphql-tag'

export default gql`mutation ($id: Int!){
  deactivateNotification(id: $id)
}`